export enum AssetType {
  TOKEN = 'token',
  EDITION = 'edition'
}
